export default __webpack_public_path__ + "b9dd2f7a21633258eb1a2018f2706da6.png";